// extracted by mini-css-extract-plugin
module.exports = {"HighlightContainer":"Highlight_HighlightContainer__2A-4y","HighlightInstance":"Highlight_HighlightInstance__2UPNl"};